import request from '@utils/request';
import url from '@utils/url';

const { HOST } = url;

export async function settleList(data) {
    const url = `${HOST}/cps-gateway/api/v1/settle/list`;

    return request({method: 'get', url: url }, data);
}

export async function settleDetail(data) {
    const url = `${HOST}/cps-gateway/api/v1/settle/channel`;

    return request({method: 'get', url: url }, data);
}

export async function updateStatus(data) {
    const url = `${HOST}/cps-gateway/api/v1/settle/status`;

    return request({method: 'post', url: url }, data);
}

export async function updateAmount(data) {
    const url = `${HOST}/cps-gateway/api/v1/settle/channel/income`;

    return request({method: 'post', url: url }, data);
}

export async function contractList(data) {
    const url = `${HOST}/cps-gateway/api/v1/settle/detail`;

    return request({method: 'get', url: url }, data);
}